


























































































































































































































































































































































































































import { CaseRecord } from "@/store/modules/types";
import { Component, Prop, Vue } from "vue-property-decorator";
import { jsPDF } from "jspdf";
import { formatPhone } from "@/utils";
import { FormQuestionType } from "@/store/modules/enums";
import moment from "moment";

@Component({
  filters: {
    phone: formatPhone,
  },
})
export default class CasePDF extends Vue {
  @Prop() readonly tabId!: string;
  @Prop() readonly caseRecord!: CaseRecord;
  pdfRecord = {
    case: {},
    patient: {},
    problems: [],
    interventions: [],
    goals: [],
    tasks: [],
    indicators: [],
    medicationNotes: Array<any>(),
    files: [],
    forms: [],
    questions: [],
    comments: Array<any>(),
  };
  getFormQuestions(formId: number) {
    return this.pdfRecord.questions.filter((item) => item["formId"] === formId);
  }
  async load() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch(
        "cases/getRecordForPDF",
        this.caseRecord.id
      );
      const div = document.createElement("DIV");
      this.pdfRecord = {
        case: data[0][0],
        patient: this.caseRecord.patientInfo,
        problems: data[1],
        interventions: data[2],
        goals: data[3],
        tasks: data[4],
        indicators: data[5],
        medicationNotes: this.caseRecord.medicationNotes,
        files: data[6],
        forms: data[7],
        questions: data[8].map((item) => {
          if (item.answer) {
            switch (item.type) {
              case FormQuestionType.DATE: {
                item.answer = moment(item.answer).format("MMM DD, YYYY");
                break;
              }
              case FormQuestionType.DATE_TIME: {
                let json = JSON.parse(item.answer);
                let date = moment(json.date).format("MMM DD, YYYY");
                let time = moment(json.time, "HH:mm:ss").format("hh:mm A");
                item.answer = date + " - " + time;
                break;
              }
              case FormQuestionType.EDITOR: {
                div.innerHTML = item.answer;
                item.answer = div.textContent || div.innerText || "";
                break;
              }
              case FormQuestionType.MULTIPLE_CHOICE: {
                let json = JSON.parse(item.answer);
                item.answer = json.join(", ");
                break;
              }
              default:
                break;
            }
          }
          return item;
        }),
        comments: this.caseRecord.comments,
      };
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async pdf() {
    this.$store.commit("main/SET_LOADING", true);
    const el = document.getElementById("case-record")!;
    const scale = 0.8;
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: [el.offsetWidth * scale, el.offsetHeight * scale + 10],
    });
    doc.html(el, {
      html2canvas: {
        scale,
      },
      callback: (doc) => {
        doc.save(`CASE_${this.caseRecord.id}.pdf`);
        this.$store.commit("main/SET_LOADING", false);
      },
      x: 0,
      y: 0,
    });
  }
  mounted() {
    this.load();
  }
}
